import AuthService, {
  AuthCredentialsDto,
  PersonaCreateDto
} from "@/api/AuthService";
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

/*
@Module({
  namespaced: true,
  name: "AuthStore",
  store: store,
  dynamic: true
})
class AuthStore extends VuexModule {
  public title = "Mi Titulo";

  counter = 30;

  @Mutation
  public setTitle(newTitle: string): void {
    this.title = newTitle;
  }

  @Action
  public updateTitle(newTitle: string): void {
    this.context.commit("setTitle", newTitle);
  }

  get titleUpperCase(): string {
    return this.title.toUpperCase();
  }

  get getCounter(): number {
    return this.counter;
  }
}

export default getModule(AuthStore);
*/
import store from "../index";

const userData = localStorage.getItem("user");
const user = userData ? JSON.parse(userData) : null;

@Module({
  namespaced: true,
  name: "AuthStore",
  store: store,
  dynamic: true
})
class AuthStore extends VuexModule {
  public loggedIn = user ? true : false;
  public user = user ? user : null;
  public person = user ? user?.persona : null;

  @Mutation
  loginSuccess(user: unknown) {
    this.loggedIn = true;
    this.user = user;
    this.person = this.user?.persona;
  }

  @Mutation
  loginFailure() {
    this.loggedIn = false;
    this.user = null;
    this.person = null;
  }

  @Mutation
  logoutSuccess() {
    this.loggedIn = false;
    this.user = null;
    this.person = null;
  }

  @Mutation
  impersonateMutation(person: any) {
    this.person = person;
  }

  @Mutation
  restorePersonMutation() {
    this.person = this.user?.persona;
  }

  @Action
  public login(authCredentialsDto: AuthCredentialsDto) {
    return AuthService.login(authCredentialsDto).then(
      user => {
        this.context.commit("loginSuccess", user);
        return Promise.resolve(user);
      },
      error => {
        this.context.commit("loginFailure");
        return Promise.reject(error);
      }
    );
  }

  @Action
  public register(createDto: PersonaCreateDto) {
    console.log(createDto);
    return AuthService.signup(createDto).then(
      response => {
        return Promise.resolve(response.data);
      },
      error => {
        return Promise.reject(error);
      }
    );
  }

  @Action
  public logout() {
    AuthService.logout();
    this.context.commit("logoutSuccess");
  }

  @Action
  public impersonate(person: any) {
    this.context.commit("impersonateMutation", person);
  }

  @Action
  public restorePerson() {
    this.context.commit("restorePersonMutation");
  }

  get originalPerson() {
    return this.user?.persona;
  }

  get getLoggedIn(): boolean {
    return this.loggedIn;
  }

  get getRole(): string {
    return this.user.role; // devuelve un string el numero del rol
  }

  get getRoleDisplay(): string {
    return this.user.roleDisplay;
  }

  get getPersonaEdad(): number {
    return this.person.edad;
  }

  get getPersonaSexo(): string {
    return this.person.sexo;
  }

  get getCarnetConadis(): string {
    return this.person.carnetConadis;
  }

  get getPersonaNombre(): string {
    return this.person.nombre;
  }
  get getPersonaID(): number {
    return this.person.id;
  }
  get isPersonaInMembrecia(): boolean {
    // por corregir
    if (this.person.membrecias && this.person.membrecias.length > 0) {
      return true;
    }
    return false;
  }
  /**
   * @description This user can only see statistics about races
   */
  get isVisitor(): boolean {
    return this.user?.role == "5";
  }
  get getCarrerasVisitanteIDs(): number[] {
    const values = this.user?.carrerasVisitanteIDs;
    if (!Array.isArray(values)) {
      return [];
    }
    return values
      .map((value: any) => Number(value))
      .filter((value: number) => Number.isInteger(value) && value > 0);
  }
  get hasCarreraVisitante(): boolean {
    return this.getCarrerasVisitanteIDs.length > 0;
  }
  get isAdmin(): boolean {
    return !["0"].includes(this.user?.role);
  }
  get getUsername(): string {
    return this.user.username;
  }
  get getPersonaIdentificacion(): string {
    return this.person.identificacion;
  }
  get getPersonaTelefono(): string {
    return this.person.telefono;
  }
}

export default getModule(AuthStore);
